var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.containerStyle),attrs:{"hakka-player":"videojs-container"}},[_c('video',{staticClass:"video-js",attrs:{"controls":"","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }